import { render, staticRenderFns } from "./HandleSelectionObjects.vue?vue&type=template&id=07bba8ef&scoped=true"
import script from "./HandleSelectionObjects.vue?vue&type=script&lang=js"
export * from "./HandleSelectionObjects.vue?vue&type=script&lang=js"
import style0 from "./HandleSelectionObjects.vue?vue&type=style&index=0&id=07bba8ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bba8ef",
  null
  
)

export default component.exports